module.exports = __webpack_public_path__ + "media/scripts/pages/join/assets/media/partners/airasiacom_logo-8d5dce834b66a7bfd6f1acb5620b9456.svg";